import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=c96d0188"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"
import style0 from "./UserList.vue?vue&type=style&index=0&id=c96d0188&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports